import { type ParticipantTask, ParticipantTaskStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCheckCircle, FaRegCircle } from 'react-icons/fa';
import { LabelsStack } from '../../components/generic/LabelsStack';
import { usePermission } from '../../hooks/usePermission';
import { ParticipantTaskActionMenu } from './ParticipantTaskActionMenu';
import { ParticipantTaskDate } from './ParticipantTaskDueDate';

interface Props {
  task: ParticipantTask;
  isDisabled?: boolean;
  onChangeStatus: () => void;
}

export const ParticipantTaskItem = (props: Props) => {
  const { task, onChangeStatus } = props;

  const updateParticipantTaskPermission = usePermission('update', 'participantTask');
  const isDisabled = props.isDisabled || !updateParticipantTaskPermission;
  const isComplete = task.status === ParticipantTaskStatus.Complete;
  const icon = task.status === ParticipantTaskStatus.Complete ? <FaCheckCircle /> : <FaRegCircle />;
  const iconColor = isComplete ? 'green.500' : 'gray.500';
  const tooltipLabel = isComplete ? 'Mark as incomplete' : 'Mark as complete';

  return (
    <ChakraV3.HStack align='start'>
      <ChakraV3.Tooltip content={tooltipLabel} disabled={isDisabled}>
        <ChakraV3.IconButton
          onClick={onChangeStatus}
          aria-label='Task status'
          variant='ghost'
          borderRadius='full'
          disabled={isDisabled}
          color={iconColor}
          size='sm'
          fontSize='lg'
        >
          {icon}
        </ChakraV3.IconButton>
      </ChakraV3.Tooltip>

      <ChakraV3.Stack gap={1}>
        <ChakraV3.Stack gap={0}>
          <ChakraV3.Text
            fontSize='sm'
            fontWeight='semibold'
            textDecor={isComplete ? 'line-through' : undefined}
          >
            {task.name}
          </ChakraV3.Text>
          <ParticipantTaskDate task={task} />
        </ChakraV3.Stack>
        <LabelsStack labels={task.labels} />
      </ChakraV3.Stack>
      <ChakraV3.Spacer />
      <ChakraV3.Stack>
        <ParticipantTaskActionMenu participantTask={task} size='sm' />
      </ChakraV3.Stack>
    </ChakraV3.HStack>
  );
};
